import * as React from 'react'
require('../base.module.scss')
import { BaseComponentProps } from '../Common/extractClassNamesFromProps'
import { extractClassNamesFromProps } from '../Common/extractClassNamesFromProps'

interface SectionAltProps extends BaseComponentProps {
  secondary?: boolean
}

export const SectionAlt: React.ComponentType<SectionAltProps>  = (props: SectionAltProps) => {
  const className = extractClassNamesFromProps(
    props,
    'avu-section-alt',
    {
      'avu-background-secondary': props.secondary
    }
  )
  return (<div className={className}>{props.children}</div>)
}

// Add displayName to preserve the component name on snapshot testing
SectionAlt.displayName = 'SectionAlt'
